import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Field } from '@builtbypixel/nucleus';
import { Input, Box, PseudoBox, Text } from '@builtbypixel/plasma';

import PlacesAutocomplete, {
    geocodeByAddress,
    getLatLng,
} from 'react-places-autocomplete';

const AddressSearch = ({ name, value, onChange }) => {
    const { setValue } = useFormContext();
    const [address, setAddress] = React.useState('');
    const [geo, setGeo] = React.useState(null);

    const handleChange = (address) => {
        setAddress(address);
    };

    React.useEffect(() => {
        if (geo) {
            setValue('location.lat', geo.lat);
            setValue('location.lng', geo.lng);
        }
    }, [geo, setValue]);

    const handleSelect = (address) => {
        geocodeByAddress(address)
            .then((results) => {
                const arrayToAddress = results[0].address_components.filter(
                    (add) =>
                        add.types.some(
                            (el) =>
                                el === 'street_number' ||
                                el === 'route' ||
                                el === 'administrative_area_level_2' ||
                                el === 'country' ||
                                el === 'postal_code'
                        )
                );
                let address = [];
                arrayToAddress.forEach((add) => {
                    address.push(add.long_name);
                });

                onChange(address.join(',\n'));
            })
            .catch((error) => console.error('Error', error));

        geocodeByAddress(address)
            .then((results) => getLatLng(results[0]))
            .then((latLng) => {
                setGeo(latLng);
            });
    };

    return (
        <>
            <PlacesAutocomplete
                value={address}
                onChange={handleChange}
                searchOptions={{
                    types: ['address'],
                }}
                onSelect={(value) => handleSelect(value, onChange)}
                shouldFetchSuggestions={address.length > 5}
            >
                {({
                    getInputProps,
                    suggestions,
                    getSuggestionItemProps,
                    loading,
                }) => (
                    <Box position='relative' w='100%' zIndex={1000}>
                        <Input
                            size='md'
                            style={{ width: '100%' }}
                            placeholder='Start typing an address...'
                            type='text'
                            loading={loading}
                            {...getInputProps()}
                            autoComplete='nope'
                        />

                        {suggestions.length !== 0 && (
                            <Box
                                position='absolute'
                                top='calc(100% + 10px)'
                                w='100%'
                                rounded='card'
                                boxShadow='md'
                                border='1px'
                                borderColor='global.borderColour'
                                bg='global.elementBg'
                            >
                                {suggestions.map((suggestion) => (
                                    <PseudoBox
                                        {...getSuggestionItemProps(suggestion)}
                                        py='10px'
                                        cursor='pointer'
                                        px='10px'
                                        _hover={{ bg: 'global.bg' }}
                                    >
                                        <Text>{suggestion.description}</Text>
                                    </PseudoBox>
                                ))}
                            </Box>
                        )}
                    </Box>
                )}
            </PlacesAutocomplete>

            <Box w='100%' my='10px'>
                <Field name='address' component='textarea' />
            </Box>
        </>
    );
};

export default AddressSearch;
